// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"e4f619b0","111":"e78cd185","161":"016df831","292":"cb392933","383":"085845e6","486":"1e00a5e3","913":"222b5095","960":"3f887d34","999":"1725ef23"}[chunkId] + ".css";
};